<template>
	<div>
		<v-data-table
			id="idListagemDocumentos"
			v-if="hasItens"
			v-model="documentosSelecionados"
			:headers="colunas"
			:items="itens"
			:show-select="temPermissaoEdicao && !modoVisualizacao && quantidadeDocumentosSelecionaveis > 0"
			item-key="id"
			hide-default-footer
			:server-items-length="totalItens"
			:options="paginacaoInterna"
			no-data-text="Nenhum documento por aqui"
			@click:row="visualizarDocumentoAnexo"
			class="arp-listview row-pointer"
		>
			<template #[`header.data-table-select`]="{}">
				<v-simple-checkbox
					id="caixaDeSelecao"
					:value="todosItensEstaoSelecionados"
					color="primary"
					@input="onSelectAll($event)"
					@click.stop
				></v-simple-checkbox>
			</template>

			<template #[`item.data-table-select`]="{ isSelected, select, item }">
				<v-simple-checkbox
					v-if="itemPodeSelecionar(item)"
					id="caixaDeSelecao"
					class="row-checkbox"
					color="primary"
					:value="isSelected"
					@input="select($event)"
					@click.stop
				></v-simple-checkbox>
			</template>

			<template #[`item.tipoRegistro`]="{ item }">
				<v-row justify="center">
					<v-tooltip top>
						<template #activator="{ on, attrs }">
							<v-icon v-bind="attrs" v-on="on" @click.prevent.stop>{{ getIconDocumento(item) }}</v-icon>
						</template>
						<span>{{ getTextTooltipDocumento(item) }}</span>
					</v-tooltip>
				</v-row>
			</template>

			<template #[`item.signatarios`]="{ item }">
				<v-menu
					v-if="ehDocumentoProcessoDigital(item)"
					id="iconeSignatariosConvidados"
					open-on-hover
					top
					left
					offset-x
					:close-on-content-click="false"
				>
					<template #activator="{ on, attrs }">
						<div v-bind="attrs" v-on="on" @click.stop>
							<v-icon size="18" class="mb-1 mr-4">mdi-account-outline</v-icon>
							<span>{{ getQuantidadeAssinadosDocumento(item) }}</span>
						</div>
					</template>

					<v-list v-if="!ehListaSignatariosVazia(item)" id="listaSignatarios">
						<v-list-item-group>
							<v-list-item v-for="signatario in getListaSignatarios(item)" :key="signatario.email">
								<v-list-item-icon>
									<v-icon size="18" :color="getCorIconeSituacaoSignatario(signatario.situacao)">
										{{ getIconeSituacaoSignatario(signatario.situacao) }}
									</v-icon>
								</v-list-item-icon>
								<v-list-item-content>
									<v-list-item-title>
										<texto-tooltip :texto="signatario.email" :tamanho-maximo="30"></texto-tooltip>
									</v-list-item-title>
								</v-list-item-content>
							</v-list-item>
							<v-list-item v-if="item.signatarios.itens.length > 5">
								<v-list-item-content>
									<v-list-item-title>
										<v-btn
											text
											block
											@click="tratarEventoVisualizarSignatarios(item.id)"
											color="primary"
											>Ver Todos
										</v-btn>
									</v-list-item-title>
								</v-list-item-content>
							</v-list-item>
						</v-list-item-group>
					</v-list>
				</v-menu>
			</template>

			<template #[`item.titulo`]="{ item }">
				<v-tooltip max-width="800" top color="black">
					<template #activator="{ on, attrs }">
						<span
							v-bind="attrs"
							v-on="on"
							:class="estaCancelado(item) ? 'text-decoration-line-through' : ''"
						>
							{{ getTituloDocumento(item) }}
						</span>
						<span>{{ item.nomeTipoDocumento }}</span>
					</template>
					<span>{{ 'Tipo: ' + item.tipoDocumento }}</span>
				</v-tooltip>
			</template>

			<template #[`item.dataCadastro`]="{ item }">
				<texto-tooltip
					:texto="formatDataFilter(item.dataCadastro)"
					:texto-tooltip="`Autor: ${item.autor}`"
				></texto-tooltip>
			</template>

			<template #item.situacao="{ item }">
				<span> {{ estaJuntado(item) }}</span>
			</template>

			<template #[`item.acoes`]="{ item }">
				<div class="d-flex flex-row justify-space-between align-content-center px-0">
					<div class="d-flex align-end ml-auto" v-if="temPermissaoEdicao && !modoVisualizacao">
						<botao-tooltip-datatable
							v-if="podeExibirAcaoAssinar(item)"
							icone="mdi-draw-pen"
							cor="grey"
							v-az-auth="
								montarPermissoes(
									permissoes.ataAssinaturaEletronicaCriar,
									permissoes.ataAssinaturaDigitalCriar,
								)
							"
							texto="Assinar"
							@click="abrirModalSelecionarTipoAssinatura(item)"
						></botao-tooltip-datatable>
						<botao-tooltip-datatable
							icone="mdi-file-edit"
							cor="grey"
							texto="Redigir"
							v-az-auth="permissoes.ataEditorTextoRedigir"
							@click="redigirDocumento(item)"
							v-if="podeExibirAcaoRedigir(item)"
						></botao-tooltip-datatable>
						<botao-tooltip-datatable
							v-if="deveExibirBotaoJuntar(item)"
							icone="mdi-file-replace"
							texto="Juntar"
							v-az-auth="permissoes.ataProcessoDigitalJuntarLote"
							cor="grey"
							@click="abrirOuFecharModalJuntarDocumento(item)"
						></botao-tooltip-datatable>
					</div>
					<div>
						<acessar-documentos-ata-btn-mais-acoes
							:documento-ou-anexo="item"
							:is-ata-pncp="isAtaPncp"
							:modo-visualizacao="modoVisualizacao"
							@baixar="baixarDocumentoAnexo(item)"
							@excluir="abrirOuFecharModalExclusaoDocumentoAnexo(item)"
							@cancelar="abrirModalInformarMotivoCancelamento(item)"
							@concluir-edicao-documento="concluirEdicaoDocumento(item)"
							@tratar-evento-desentranhar="tratarEventoDesentranhar(item)"
							@convidar-signatarios="tratarEventoConvidarSignatarios(item)"
							@enviar-pncp="abrirOuFecharModalEnviarDocumentoPncp(item)"
							@excluir-pncp="abrirOuFecharModalExcluirDocumentoPncp(item)"
							@enviar-fornecedor="tratarEventoEnviarFornecedor(item)"
						></acessar-documentos-ata-btn-mais-acoes>
					</div>
				</div>
			</template>
		</v-data-table>

		<paginacao-tabela
			v-if="hasItens"
			:page.sync="paginacaoInterna.page"
			:rows-per-page.sync="paginacaoInterna.rowsPerPage"
			:totalPaginas="totalPaginas"
			:totalItens="totalItens"
			@resetar-page="resetarPage"
		></paginacao-tabela>

		<div v-if="temPermissaoEdicao">
			<modal-confirmacao
				id="excluir-documento-ou-anexo-listagem"
				:exibir="exibirModalExclusaoDocumentoAnexo"
				:mensagem="getMensagemModalConfirmacaoExclusao()"
				@fechar-modal="abrirOuFecharModalExclusaoDocumentoAnexo"
				@confirmar="excluirDocumentoAnexo"
				:subtituloModal="'Deseja realmente excluir'"
				:tituloModal="getTituloModalConfirmacaoExclusao()"
			></modal-confirmacao>

			<formulario-motivo-cancelamento
				id="cancelar-documento-juntado"
				v-if="exibirModalInformarMotivoCancelamento"
				:exibir="exibirModalInformarMotivoCancelamento"
				titulo="Informe o Motivo do Cancelamento"
				@fechar-modal="abrirModalInformarMotivoCancelamento"
				:titulo-documento="documentoSelecionado.titulo"
				:id-documento="documentoSelecionado.id"
				@confirmar="cancelarDocumento"
			></formulario-motivo-cancelamento>

			<modal-confirmacao
				id="juntar-documento-listagem"
				:tituloModal="getMensagemModalConfirmacaoJuntado()"
				:subtituloModal="mensagemModalJuntarDocumento"
				:exibir="exibirModalJuntarDocumento"
				:mensagem="'Deseja realmente juntar?'"
				:label-acao-confirmar="'CONFIRMAR'"
				:label-acao-cancelar="'CANCELAR'"
				@fechar-modal="cancelarAcaoJuntarDocumentoProcessoDigital"
				@confirmar="juntarDocumentoProcessoDigital"
			></modal-confirmacao>
			<modal-confirmacao
				id="enviar-documento-pncp-listagem"
				:exibir="exibirModalEnviarDocumentoPncp"
				:mensagem="'Deseja enviar o documento ao PNCP?'"
				@fechar-modal="abrirOuFecharModalEnviarDocumentoPncp"
				@confirmar="enviarDocumentoPncp"
				:tituloModal="getTituloModalConfirmacaoPncp()"
			></modal-confirmacao>
			<modal-confirmacao
				id="excluir-documento-pncp-listagem"
				:exibir="exibirModalExcluirDocumentoPncp"
				:mensagem="'Essa ação remove o documento no PNCP e não poderá ser desfeita.'"
				:subtituloModal="'deseja continuar?'"
				@fechar-modal="abrirOuFecharModalExcluirDocumentoPncp"
				@confirmar="excluirDocumentoPncp"
				:tituloModal="getTituloModalExcluirPncp()"
			></modal-confirmacao>
		</div>
	</div>
</template>
<script>
import { cloneDeep } from 'lodash'
import tabelaMixin from '@/views/mixins/tabela'
import documentoMixin from '@/views/mixins/documento'
import AcessarDocumentosAtaBtnMaisAcoes from '@/views/pages/ata/acessar/gestao-da-ata/documentos/botoes/AcessarDocumentosAtaBtnMaisAcoes.vue'
import {
	actionTypes,
	getterTypes,
	mutationTypes,
	opcaoSimNao,
	situacaoSignatarioDocumentoProcessoDigital,
	situacoes,
} from '@/core/constants'
import PaginacaoTabela from '@/views/components/PaginacaoTabela.vue'
import { TabelaColunaUtils } from '@/core/utils'
import BotaoTooltipDatatable from '@/views/components/BotaoTooltipDatatable.vue'
import FormularioMotivoCancelamento from '@/views/components/documentos/motivo-cancelamento/FormularioMotivoCancelamento.vue'
import signatario from '@/views/mixins/signatarios/signatario'
import TextoTooltip from '@/views/components/TextoTooltip.vue'
import validacaoAta from '@/views/mixins/validacaoAta'
import { mapGetters } from 'vuex'
import ModalConfirmacao from '@/views/components/ModalConfirmacao'
import formatDataFilter from '@/views/filters/format-data-filter'

export default {
	name: 'editar-documentos-penalidades-ata-listagem',
	components: {
		ModalConfirmacao,
		TextoTooltip,
		BotaoTooltipDatatable,
		PaginacaoTabela,
		AcessarDocumentosAtaBtnMaisAcoes,
		FormularioMotivoCancelamento,
	},
	mixins: [tabelaMixin, documentoMixin, signatario, validacaoAta],
	props: {
		itens: {
			type: Array,
			required: true,
		},
		ata: {
			type: Object,
			required: true,
		},
		idAta: {
			type: [String, Number],
			required: true,
		},
		modoVisualizacao: {
			type: Boolean,
			default: false,
		},
	},
	emits: [
		'continuar-elaboracao-termo-desentranhamento',
		'criar-termo-desentranhamento',
		'convidar-signatarios',
		'visualizar-signatarios',
		'enviar-fornecedor',
	],
	data() {
		return {
			paginacaoInterna: this.paginacao,
			exibirModalExclusaoDocumentoAnexo: false,
			exibirModalJuntarDocumento: false,
			mensagemModalJuntarDocumento: null,
			documentoSelecionado: null,
			exibirModalInformarMotivoCancelamento: false,
			isProcessoDigitalAtivo: this.$store.state.parametrosSistema.isProcessoDigitalAtivo,
			exibirModalEnviarDocumentoPncp: false,
			exibirModalExcluirDocumentoPncp: false,
			isAtaPncp: this.ata.isEnviadaPncp,
		}
	},
	computed: {
		...mapGetters({
			cabecalho: getterTypes.ATA.GET_ATA_PARA_CABECALHO,
		}),
		documentosSelecionados: {
			get() {
				return this.$store.state.ata.documentosAta.documentosSelecionados
			},
			set(item) {
				this.$store.commit(mutationTypes.ATA.DOCUMENTOS_ATA.CHECKBOX.DOCUMENTOS_SELECIONADOS, item)
				this.$store.commit(mutationTypes.COMUM.MODAL_ASSINATURA_FLOWBEE.SET_DOCUMENTOS, item)
			},
		},
		isSelecionouTodosItensDaListaDeDocumentosAta: {
			get() {
				return this.$store.state.ata.documentosAta.isSelecionouTodosItensDaListaDeDocumentosAta
			},
		},
		todosItensEstaoSelecionados() {
			return this.quantidadeDocumentosSelecionaveis === this.quantidadeDocumentosSelecionadosPaginaAtual
		},
		quantidadeDocumentosSelecionadosPaginaAtual() {
			return this.documentosSelecionados.filter((documentoSelecionado) => {
				if (this.itens.findIndex((documento) => documento.id === documentoSelecionado.id) !== -1) {
					return documentoSelecionado
				}
			}).length
		},
		quantidadeDocumentosSelecionaveis() {
			return this.itens.filter((documento) => this.itemPodeSelecionar(documento)).length
		},
		colunas() {
			return this.montarColunas()
		},
	},
	methods: {
		formatDataFilter,
		async carregarInformacoesDaAta() {
			await this.$store.dispatch(actionTypes.ATA.BUSCAR_POR_ID, this.idAta)
			await this.montaInformacoes()
		},
		montaInformacoes() {
			this.atualizaCabecalho(this.cabecalho)
		},
		atualizaCabecalho(informacoes) {
			this.$store.commit(mutationTypes.COMUM.SET_INFO_CABECALHO, informacoes)
		},
		deveExibirBotaoJuntar(item) {
			const situacoesAtaValida = this.estaEfetivado(this.ata.situacao) || this.estaCancelada(this.ata.situacao)
			return situacoesAtaValida && item.podeJuntar
		},
		tratarEventoVisualizarSignatarios(idDocumento) {
			this.$emit('visualizar-signatarios', idDocumento)
		},
		ehDocumentoProcessoDigital(item) {
			return item.situacao && item.situacao !== situacoes.DOCUMENTO.CRIADO.value && this.isProcessoDigitalAtivo
		},
		getOrdemSituacao(situacao) {
			if (situacao === situacaoSignatarioDocumentoProcessoDigital.ASSINADO.value) {
				return situacaoSignatarioDocumentoProcessoDigital.ASSINADO.ordem
			}

			if (situacao === situacaoSignatarioDocumentoProcessoDigital.EXPIRADO.value) {
				return situacaoSignatarioDocumentoProcessoDigital.EXPIRADO.ordem
			}

			if (situacao === situacaoSignatarioDocumentoProcessoDigital.ENVIADO.value) {
				return situacaoSignatarioDocumentoProcessoDigital.ENVIADO.ordem
			}

			if (situacao === situacaoSignatarioDocumentoProcessoDigital.EXCLUIDO.value) {
				return situacaoSignatarioDocumentoProcessoDigital.EXCLUIDO.ordem
			}
		},
		getListaSignatarios(documento) {
			let documentoCopia = cloneDeep(documento)
			return documentoCopia.signatarios.itens
				.sort((item1, item2) => {
					if (this.getOrdemSituacao(item1.situacao) > this.getOrdemSituacao(item2.situacao)) return -1

					if (this.getOrdemSituacao(item1.situacao) < this.getOrdemSituacao(item2.situacao)) return 1

					return 0
				})
				.slice(0, 5)
		},
		getQuantidadeAssinadosDocumento(documento) {
			if (documento.signatarios) {
				return `${documento.signatarios.quantidadeSignatariosAssinaram} / ${documento.signatarios.quantidadeSignatariosConvidados}`
			}
		},
		ehListaSignatariosVazia(documento) {
			return !documento.signatarios || documento.signatarios.itens.length === 0
		},
		tratarEventoConvidarSignatarios(documento) {
			this.$emit('convidar-signatarios', { idAssociacao: documento.id, titulo: documento.titulo })
		},
		tratarEventoDesentranhar(documento) {
			if (this.possuiTermoDesentranhamento(documento)) {
				this.$emit('continuar-elaboracao-termo-desentranhamento', documento)
				return
			}
			this.$emit('criar-termo-desentranhamento', documento)
		},
		tratarEventoEnviarFornecedor(documento) {
			this.$emit('enviar-fornecedor', { idAssociacao: documento.id, emailFornecedor: documento.emailFornecedor })
		},

		montarColunas() {
			let colunas = [
				new TabelaColunaUtils('', 'tipoRegistro', '2%'),
				new TabelaColunaUtils('Título', 'titulo', '40%'),
				new TabelaColunaUtils('Data cadastro', 'dataCadastro', '15%'),
			]

			if (this.$store.state.parametrosSistema.isProcessoDigitalAtivo === true) {
				colunas.push(new TabelaColunaUtils('Convidados', 'signatarios', '15%'))
				colunas.push(new TabelaColunaUtils('Juntado', 'situacao', '10%'))
			}

			if (this.$store.getters[getterTypes.ATA.GET_TEM_PERMISSAO_EDICAO] || this.modoVisualizacao) {
				colunas.push(new TabelaColunaUtils('Ações', 'acoes', '12%'))
			}

			return colunas
		},
		async visualizarDocumentoAnexo(documentoOuAnexo) {
			if (this.isDocumento(documentoOuAnexo) && this.documentoEstaCriado(documentoOuAnexo)) {
				const editor = await this.$store.dispatch(
					actionTypes.ATA.DOCUMENTOS_ATA.DOCUMENTOS.EDITOR_TEXTO.VISUALIZAR,
					documentoOuAnexo.id,
				)
				this.redirecionarPara(editor.urlVisualizar)

				return
			}

			await this.baixarDocumentoAnexo(documentoOuAnexo)
		},
		async redigirDocumento(documento) {
			if (this.isDocumento(documento)) {
				const editor = await this.$store.dispatch(
					actionTypes.ATA.DOCUMENTOS_ATA.DOCUMENTOS.EDITOR_TEXTO.REDIGIR,
					documento.id,
				)
				this.redirecionarPara(editor.urlEdicao)
			}
		},
		async baixarDocumentoAnexo(documentoAnexo) {
			await this.$store.dispatch(actionTypes.ATA.DOCUMENTOS_ATA.BAIXAR_DOCUMENTO_ANEXO, documentoAnexo)
		},
		async excluirDocumentoAnexo() {
			await this.$store.dispatch(
				actionTypes.ATA.DOCUMENTOS_ATA.EXCLUIR_DOCUMENTO_OU_ANEXO,
				this.documentoSelecionado,
			)

			this.corrigirPaginacaoQuandoContemApenasUmDocumento()
			await this.$emit('recarregar-listagem-externa')
			this.exibeMensagemSucessoExclusaoDocumento()
			this.abrirOuFecharModalExclusaoDocumentoAnexo(null)
			await this.carregarInformacoesDaAta()
		},
		async juntarDocumentoProcessoDigital() {
			const payload = {
				id: this.ata.id,
				idsDocumentos: [this.documentoSelecionado.id],
			}

			if (this.documentoSelecionado.ehTermoDesentranhamento === opcaoSimNao.SIM.value) {
				await this.$store.dispatch(
					actionTypes.ATA.DOCUMENTOS_ATA.PROCESSO_DIGITAL.DESENTRANHAMENTO.JUNTAR_TERMO,
					this.documentoSelecionado.id,
				)
			} else {
				await this.$store.dispatch(
					actionTypes.ATA.DOCUMENTOS_ATA.PROCESSO_DIGITAL.JUNTAR_LOTE_DOCUMENTOS,
					payload,
				)
			}
			this.documentoSelecionado.situacao = situacoes.DOCUMENTO.JUNTADO.value
			this.documentoSelecionado = null
			this.documentosSelecionados = []
			this.cancelarAcaoJuntarDocumentoProcessoDigital()
			this.mostrarNotificacaoSucesso('Documento foi juntado ao processo digital.')
			await this.$emit('recarregar-listagem-externa')
		},
		async concluirEdicaoDocumento(documento) {
			await this.$store.dispatch(actionTypes.ATA.DOCUMENTOS_ATA.DOCUMENTOS.EDITOR_TEXTO.SINCRONIZAR, documento.id)
			this.mostrarNotificacaoSucesso('Edição do documento concluída com sucesso')
			await this.carregarInformacoesDaAta()
			await this.$emit('recarregar-listagem-externa')
		},
		onSelectAll(value) {
			if (value && !this.isSelecionouTodosItensDaListaDeDocumentosAta) {
				this.selecionarTodosItensListagem()
			} else {
				this.$store.commit(mutationTypes.ATA.DOCUMENTOS_ATA.CHECKBOX.DESFAZER_SELECAO_ITENS_LISTAGEM)
			}
		},
		abrirModalSelecionarTipoAssinatura(documento) {
			this.$store.commit(mutationTypes.COMUM.MODAL_ASSINATURA_FLOWBEE.SET_DOCUMENTOS, [documento])
			this.$store.commit(mutationTypes.COMUM.MODAL_ASSINATURA_FLOWBEE.SET_EXIBICAO, true)
		},
		abrirOuFecharModalExclusaoDocumentoAnexo(documento) {
			this.documentoSelecionado = documento
			this.exibirModalExclusaoDocumentoAnexo = !this.exibirModalExclusaoDocumentoAnexo
		},
		abrirOuFecharModalJuntarDocumento(documento) {
			this.documentoSelecionado = documento
			this.mensagemModalJuntarDocumento = documento.titulo
			this.exibirModalJuntarDocumento = !this.exibirModalJuntarDocumento
		},
		cancelarAcaoJuntarDocumentoProcessoDigital() {
			this.documentoSelecionado = null
			this.exibirModalJuntarDocumento = false
		},
		resetarPage() {
			this.$emit('resetar-page')
		},
		podeExibirAcaoRedigir(item) {
			return this.isDocumento(item) && this.documentoEstaCriado(item) && item.jaAssinou === false
		},
		podeExibirAcaoAssinar(item) {
			return (
				(this.isAnexoPdf(item) || this.isDocumento(item)) &&
				this.documentoOuAnexoEstaEmRascunho(item) &&
				item.jaAssinou === false
			)
		},
		estaJuntado(docOuAnexo) {
			if (this.documentoOuAnexoEstaJuntado(docOuAnexo)) return 'Sim'
			return 'Não'
		},
		estaCancelado(docOuAnexo) {
			return this.documentoOuAnexoEstaCancelado(docOuAnexo)
		},
		exibeMensagemSucessoExclusaoDocumento() {
			this.mostrarNotificacaoSucesso(`${this.getTextTipoDocumentoSelecionado()} da ata foi excluído com sucesso!`)
		},
		getTextTipoDocumentoSelecionado() {
			if (this.documentoSelecionado) {
				return this.tipoDocumentoRegistro[this.documentoSelecionado.tipoRegistroDocumento].text
			}

			return ''
		},
		getIconDocumento(item) {
			if (item.isDocPublico) return this.tipoDocumentoRegistro[item.tipoRegistroDocumento].icon_sended

			return this.tipoDocumentoRegistro[item.tipoRegistroDocumento].icon
		},
		getTextTooltipDocumento(item) {
			if (item.isDocPublico) return this.tipoDocumentoRegistro[item.tipoRegistroDocumento].text_sended

			return this.tipoDocumentoRegistro[item.tipoRegistroDocumento].text
		},
		getTituloDocumento(documento) {
			return `${documento.titulo}${
				this.isAnexo(documento.tipoRegistroDocumento)
					? ' ' + '(' + this.getConstantText(documento.extensao, this.extensoesArquivos, 'text') + ')'
					: ''
			}`
		},
		getTituloModalConfirmacaoExclusao() {
			return `Excluir ${this.getTextTipoDocumentoSelecionado()}`
		},
		getTituloModalConfirmacaoPncp() {
			return `Enviar ${this.getTextTipoDocumentoSelecionado()}`
		},
		getTituloModalExcluirPncp() {
			return `Excluir ${this.getTextTipoDocumentoSelecionado()}`
		},
		getMensagemModalConfirmacaoExclusao() {
			return `O ${this.getTextTipoDocumentoSelecionado().toLowerCase()} será excluído e não poderá ser recuperado!`
		},
		getMensagemModalConfirmacaoJuntado() {
			return `Atenção! O ${this.getTextTipoDocumentoSelecionado().toLowerCase()} a seguir será juntado ao processo digital:`
		},
		corrigirPaginacaoQuandoContemApenasUmDocumento() {
			if (this.itens.length === 1 && this.paginacaoInterna.page > 1) {
				this.paginacaoInterna.page -= 1
			}
		},
		selecionarTodosItensListagem() {
			this.$store.commit(mutationTypes.ATA.DOCUMENTOS_ATA.CHECKBOX.SET_IS_SELECIONOU_TODOS_ITENS)
			this.documentosSelecionados = this.itens.filter((item) => this.itemPodeSelecionar(item))
		},
		possuiTermoDesentranhamento(documento) {
			return opcaoSimNao.SIM.value === documento.possuiTermoDesentranhamento
		},

		abrirModalInformarMotivoCancelamento(documento) {
			this.documentoSelecionado = documento
			this.exibirModalInformarMotivoCancelamento = !this.exibirModalInformarMotivoCancelamento
		},
		async cancelarDocumento(payload) {
			this.exibirModalInformarMotivoCancelamento = !this.exibirModalInformarMotivoCancelamento

			await this.$store.dispatch(actionTypes.ATA.DOCUMENTOS_ATA.PROCESSO_DIGITAL.CANCELAR_DOCUMENTO, payload)

			this.mostrarNotificacaoSucesso('Alteração realizada com sucesso')
			await this.$emit('recarregar-listagem-externa')
		},
		itemPodeSelecionar(item) {
			return (
				this.temProcessoDigital(item) &&
				!this.documentoOuAnexoEstaJuntado(item) &&
				!this.documentoOuAnexoEstaCancelado(item) &&
				!this.possuiTermoDesentranhamento(item)
			)
		},
		abrirOuFecharModalEnviarDocumentoPncp(documento) {
			this.documentoSelecionado = documento
			this.exibirModalEnviarDocumentoPncp = !this.exibirModalEnviarDocumentoPncp
		},
		async enviarDocumentoPncp() {
			const payload = {
				ataId: this.ata.id,
				documentoId: this.documentoSelecionado.id,
			}
			await this.$store.dispatch(actionTypes.ATA.DOCUMENTOS_ATA.ENVIAR_DOCUMENTO_PARA_PNCP, payload)

			await this.$emit('recarregar-listagem-externa')
			this.mostrarNotificacaoSucesso('Documento enviado ao PNCP')
			this.abrirOuFecharModalEnviarDocumentoPncp(this.documentoSelecionado)
		},
		abrirOuFecharModalExcluirDocumentoPncp(documento) {
			this.documentoSelecionado = documento
			this.exibirModalExcluirDocumentoPncp = !this.exibirModalExcluirDocumentoPncp
		},
		async excluirDocumentoPncp() {
			const payload = {
				documentoId: this.documentoSelecionado.id,
			}
			await this.$store.dispatch(actionTypes.ATA.DOCUMENTOS_ATA.EXCLUIR_DOCUMENTO_NO_PNCP, payload)

			await this.$emit('recarregar-listagem-externa')
			this.mostrarNotificacaoSucesso('Documento excluído no PNCP')
			this.abrirOuFecharModalExcluirDocumentoPncp(this.documentoSelecionado)
		},
	},
}
</script>
